import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

import webConfig from '~/config'
import pinia from './pinia'

export function initSentry(app: App<Element>) {
  Sentry.init({
    app,
    dsn: 'https://44ebc5a13baf91dce6bd1271cdbc14cd@o4508087536582656.ingest.us.sentry.io/4508212089520128',
    integrations: [],
    maxBreadcrumbs: 50,
    environment: webConfig.app.envName === 'develop' ? 'development' : webConfig.app.envName,
    release: webConfig.app.version,
    sendDefaultPii: true,

    // Sample all errors in production, otherwise 70% of errors will be sampled
    sampleRate: webConfig.app.envName.startsWith('production') ? 1.0 : 0.6,
    // Reduce tracing in production to reduce the amount of data sent to Sentry
    tracesSampleRate: webConfig.app.envName.startsWith('production') ? 0.5 : 0.8,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api(?:\.(?:dev|sandbox))?\.oliveltd\.com\//,
    ],
    // Session Replay
    replaysSessionSampleRate: webConfig.app.envName.startsWith('production') ? 0.6 : 0.2, // 60% in prod, 20% in sandbox (off in dev)
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

export function configureSentry(app: App<Element>, router: Router) {
  pinia.use(Sentry.createSentryPiniaPlugin())

  Sentry.addIntegration(Sentry.vueIntegration({
    tracingOptions: {
      trackComponents: true,
      hooks: [
        'mount',
        'unmount',
        'update',
      ],
    },
  }))

  Sentry.addIntegration(Sentry.browserTracingIntegration({ router }))
  Sentry.addIntegration(Sentry.httpClientIntegration())

  if (webConfig.app.envName.startsWith('production')) {
    Sentry.addIntegration(Sentry.replayIntegration())
  }
}
